import NotificationPermission from './NotificationPermission';

export default NotificationPermission;

